import styled from "@emotion/styled";

export const Grid = styled.div`
  display: grid;
`;
